/* ════════════════════════════════════════════════════════
   rtl-carousel-fix.js — Best4Home
   ────────────────────────────────────────────────────────
   WHY THE PREVIOUS APPROACH FAILED:
   ThemeScroll stores onNavClick as a BOUND copy:
     this.nav.addEventListener('click', this.onNavClick.bind(this))
   Patching the prototype after elements connect has no effect —
   the listener already holds a reference to the old function.

   CORRECT APPROACH:
   Intercept clicks in the CAPTURE phase (runs before ThemeScroll's
   bubble listener on .theme-scroll-nav). Swap btn.name so
   ThemeScroll reads the flipped direction, then restore it.

   onNavDisabled IS called as this.onNavDisabled() (direct call, not
   a stored bound ref) so prototype patching DOES work there.
════════════════════════════════════════════════════════ */
(function () {
  if (document.documentElement.dir !== 'rtl') return;

  if (window.__b4hRtlCarouselFixInstalled) return;
  window.__b4hRtlCarouselFixInstalled = true;

  /* ── Fix 1: Flip click direction via capture-phase intercept ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.flickity-nav');
    if (!btn) return;
    var orig = btn.name;
    if (orig === 'next')      btn.name = 'prev';
    else if (orig === 'prev') btn.name = 'next';
    // Restore after ThemeScroll's handler has already read it
    setTimeout(function () { btn.name = orig; }, 0);
  }, true /* capture = runs before ThemeScroll's bubble listener */);

  /* ── Fix 2: Correct disabled-state for RTL scrollLeft range ── */
  // onNavDisabled is called as this.onNavDisabled() — direct method
  // call, not a bound copy — so prototype patch is safe here.
  function patch() {
    var proto = customElements.get('theme-scroll').prototype;
    proto.onNavDisabled = function (scrollLeft) {
      if (scrollLeft === undefined) scrollLeft = this.viewport.scrollLeft;
      // In RTL: scrollLeft=0 = rightmost (start), goes negative leftward
      var maxScroll = this.viewport.scrollWidth - this.viewport.offsetWidth;
      if (this.navPrev) {
        // Disable "prev" (right arrow) only when we're at the very start
        this.navPrev.disabled = scrollLeft >= 0;
      }
      if (this.navNext) {
        // Disable "next" (left arrow) when scrolled to the leftmost end
        this.navNext.disabled = Math.floor(Math.abs(scrollLeft)) >= maxScroll;
      }
    };
  }

  if (customElements.get('theme-scroll')) {
    patch(); // element already defined (script loaded late)
  } else {
    customElements.whenDefined('theme-scroll').then(patch);
  }
})();
